import { RESET_USER } from ".";
import { methods } from "../constants/constants";
import { getAcademieById } from "../utils/dataHandlers/AcademiesDataHandler";

export const types = {
  GET_ACADEMIES_BEGINS: 'ACADEMIES/GET_ACADEMIES_BEGINS',
  GET_ACADEMIES_SUCCESS: 'ACADEMIES/GET_ACADEMIES_SUCCESS',
  GET_ACADEMIES_FAILURE: 'ACADEMIES/GET_ACADEMIES_FAILURE',
  GET_ACADEMIES_UPDATE: 'ACADEMIES/GET_ACADEMIES_UPDATE',

  POST_ACADEMIES_BEGINS: 'ACADEMIES/POST_ACADEMIES_BEGINS',
  POST_ACADEMIES_SUCCESS: 'ACADEMIES/POST_ACADEMIES_SUCCESS',
  POST_ACADEMIES_FAILURE: 'ACADEMIES/POST_ACADEMIES_FAILURE',
  RESET_POST_ACADEMIES: 'ACADEMIES/RESET_POST_ACADEMIES',

  EDIT_ACADEMIES_BEGINS: 'ACADEMIES/EDIT_ACADEMIES_BEGINS',
  EDIT_ACADEMIES_SUCCESS: 'ACADEMIES/EDIT_ACADEMIES_SUCCESS',
  EDIT_ACADEMIES_FAILURE: 'ACADEMIES/EDIT_ACADEMIES_FAILURE',
  RESET_EDIT_ACADEMIES: 'ACADEMIES/RESET_EDIT_ACADEMIES',


  DELETE_ACADEMIES_BEGINS: 'ACADEMIES/DELETE_ACADEMIES_BEGINS',
  DELETE_ACADEMIES_SUCCESS: 'ACADEMIES/DELETE_ACADEMIES_SUCCESS',
  DELETE_ACADEMIES_FAILURE: 'ACADEMIES/DELETE_ACADEMIES_FAILURE',
    RESET_DELETE_ACADEMIES: 'ACADEMIES/RESET_DELETE_ACADEMIES',

    GET_ACADEMY_DELETE_IMPACT_BEGINS: 'ACADEMIES/GET_ACADEMY_DELETE_IMPACT_BEGINS',
    GET_ACADEMY_DELETE_IMPACT_SUCCESS: 'ACADEMIES/GET_ACADEMY_DELETE_IMPACT_SUCCESS',
    GET_ACADEMY_DELETE_IMPACT_FAILURE: 'ACADEMIES/GET_ACADEMY_DELETE_IMPACT_FAILURE',

    GET_PLATAFORMAS_BEGINS: 'PLATAFORMAS/GET_PLATAFORMAS_BEGINS',
    GET_PLATAFORMAS_SUCCESS: 'PLATAFORMAS/GET_PLATAFORMAS_SUCCESS',
    GET_PLATAFORMAS_FAILURE: 'PLATAFORMAS/GET_PLATAFORMAS_FAILURE',
    GET_PLATAFORMAS_UPDATE: 'PLATAFORMAS/GET_PLATAFORMAS_UPDATE',       

}

export const initialState = {
  academies: [],
  academiesFetching: false,
  academiesError: null,

  academiesStatus: null,
  academiesStatusData: null,
  academiesStatusFetching: false,
  academiesStatusError: null,

  academiesEditStatus: null,
  academiesEditStatusData: null,
  academiesEditStatusFetching: false,
  academiesEditStatusError: null,

  academiesDeleteStatus: null,
  academiesDeleteStatusData: null,
  academiesDeleteStatusFetching: false,
  academiesDeleteStatusError: null,

  academiesDeleteImpactById: {},
  academiesDeleteImpactFetchingById: {},
  academiesDeleteImpactErrorById: {},

  plataformas: [],
  plataformasFetching: false,
  plataformasError: null
}

const AcademiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_USER:
      return initialState;
      case types.GET_PLATAFORMAS_BEGINS: {
          return {
              ...state,
              plataformasFetching: true,
              plataformasError: null,
          }
      }
      case types.GET_PLATAFORMAS_SUCCESS: {
          const data = action.payload;
          return {
              ...state,
              plataformas: data,
              plataformasFetching: false,
              plataformasError: null,
          }
      }
      case types.GET_PLATAFORMAS_FAILURE:
          return {
              ...state,
              plataformasFetching: false,
              plataformasError: action.payload,
          }
    case types.GET_ACADEMIES_BEGINS: {
      return {
        ...state,
        academiesFetching: true,
        academiesError: null,
      }
    }
    case types.GET_ACADEMIES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        academies: data,
        academiesFetching: false,
        academiesError: null,
      }
    }
    case types.GET_ACADEMIES_FAILURE:
      return { 
        ...state,
        academiesFetching: false,
        academiesError: action.payload,
      }
    case types.GET_ACADEMIES_UPDATE: {
      const { data, method } = action.payload;
      const currentAcademies = Array.isArray(state.academies) ? [...state.academies] : [];
      const exist = getAcademieById(currentAcademies, data.id);
      let updateAcademies = currentAcademies;

      if (method === methods.DELETE) {
        updateAcademies = currentAcademies.filter((academie) => academie.id !== data.id);
      } else {
        if (!exist) {
          updateAcademies = [...currentAcademies, data];
        } else {
          updateAcademies = currentAcademies.map((academie) => (
            academie.id === data.id
              ? {
                  ...academie,
                  ...data,
                }
              : academie
          ));
        }
      }

      return {
        ...state,
        academies: updateAcademies,
        academiesFetching: false,
        academiesError: null,
      }
    }
    case types.POST_ACADEMIES_BEGINS: {
      return {
        ...state,
        academiesStatusFetching: true,
        academiesStatusError: null,
      }
    }
    case types.POST_ACADEMIES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        academiesStatus: data.status,
        academiesStatusData: data.data,
        academiesStatusFetching: false,
        academiesStatusError: null,
      }
    }
    case types.POST_ACADEMIES_FAILURE:
      return { 
        ...state,
        academiesStatusFetching: false,
        academiesStatusError: action.payload,
      }
      case types.RESET_POST_ACADEMIES:
      return { 
        ...state,
        academiesStatus: null,
        academiesStatusData: null,
        academiesStatusFetching: false,
        academiesStatusError: null,
      }
    case types.EDIT_ACADEMIES_BEGINS: {
      return {
        ...state,
        academiesEditStatusFetching: true,
        academiesEditStatusError: null,
      }
    }
    case types.EDIT_ACADEMIES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        academiesEditStatus: data.status,
        academiesEditStatusData: data.data,
        academiesEditStatusFetching: false,
        academiesEditStatusError: null,
      }
    }
    case types.EDIT_ACADEMIES_FAILURE:
      return { 
        ...state,
        academiesEditStatusFetching: false,
        academiesEditStatusError: action.payload,
      }
    case types.RESET_EDIT_ACADEMIES:
      return { 
        ...state,
        academiesEditStatus: null,
        academiesEditStatusData: null,
        academiesEditStatusFetching: false,
        academiesEditStatusError: null,
      }
    case types.DELETE_ACADEMIES_BEGINS: {
      return {
        ...state,
        academiesDeleteStatusFetching: true,
        academiesDeleteStatusError: null,
      }
    }
    case types.DELETE_ACADEMIES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        academiesDeleteStatus: data.status,
        academiesDeleteStatusData: data.data,
        academiesDeleteStatusFetching: false,
        academiesDeleteStatusError: null,
      }
    }
    case types.DELETE_ACADEMIES_FAILURE:
      return { 
        ...state,
        academiesDeleteStatusFetching: false,
        academiesDeleteStatusError: action.payload,
      }
    case types.RESET_DELETE_ACADEMIES:
      return { 
        ...state,
        academiesDeleteStatus: null,
        academiesDeleteStatusData: null,
        academiesDeleteStatusFetching: false,
        academiesDeleteStatusError: null,
      }
    case types.GET_ACADEMY_DELETE_IMPACT_BEGINS:
      return {
        ...state,
        academiesDeleteImpactFetchingById: {
          ...state.academiesDeleteImpactFetchingById,
          [action.idAcademia]: true,
        },
        academiesDeleteImpactErrorById: {
          ...state.academiesDeleteImpactErrorById,
          [action.idAcademia]: null,
        },
      }
    case types.GET_ACADEMY_DELETE_IMPACT_SUCCESS:
      return {
        ...state,
        academiesDeleteImpactById: {
          ...state.academiesDeleteImpactById,
          [action.idAcademia]: action.payload,
        },
        academiesDeleteImpactFetchingById: {
          ...state.academiesDeleteImpactFetchingById,
          [action.idAcademia]: false,
        },
        academiesDeleteImpactErrorById: {
          ...state.academiesDeleteImpactErrorById,
          [action.idAcademia]: null,
        },
      }
    case types.GET_ACADEMY_DELETE_IMPACT_FAILURE:
      return {
        ...state,
        academiesDeleteImpactFetchingById: {
          ...state.academiesDeleteImpactFetchingById,
          [action.idAcademia]: false,
        },
        academiesDeleteImpactErrorById: {
          ...state.academiesDeleteImpactErrorById,
          [action.idAcademia]: action.payload,
        },
      }
  default:
    return state
  }
}

export const actions = {
    getPlataformas: () => ({ type: types.GET_PLATAFORMAS_BEGINS }),
    successGetPlataformas: data => ({ type: types.GET_PLATAFORMAS_SUCCESS, payload: data, }),
    errorGetPlataformas: error => ({ type: types.GET_PLATAFORMAS_FAILURE, payload: error, }),

  getAcademies: () => ({ type: types.GET_ACADEMIES_BEGINS }),
  successGetAcademies: data => ({ type: types.GET_ACADEMIES_SUCCESS, payload: data, }),
  errorGetAcademies: error => ({ type: types.GET_ACADEMIES_FAILURE, payload: error, }),
  updateAcademies: (data, method) => ({ type: types.GET_ACADEMIES_UPDATE, payload: { data, method }, }),

  postAcademies: academie => ({ type: types.POST_ACADEMIES_BEGINS, academie }),
  successPostAcademies: data => ({ type: types.POST_ACADEMIES_SUCCESS, payload: data, }),
  errorPostAcademies: error => ({ type: types.POST_ACADEMIES_FAILURE, payload: error, }),
  resetPostAcademies: () => ({ type: types.RESET_POST_ACADEMIES }),

  editAcademies: academie => ({ type: types.EDIT_ACADEMIES_BEGINS, academie }),
  successEditAcademies: data => ({ type: types.EDIT_ACADEMIES_SUCCESS, payload: data, }),
  errorEditAcademies: error => ({ type: types.EDIT_ACADEMIES_FAILURE, payload: error, }),
  resetEditAcademies: () => ({ type: types.RESET_EDIT_ACADEMIES }),

  deleteAcademies: academie => ({ type: types.DELETE_ACADEMIES_BEGINS, academie }),
  successDeleteAcademies: data => ({ type: types.DELETE_ACADEMIES_SUCCESS, payload: data, }),
  errorDeleteAcademies: error => ({ type: types.DELETE_ACADEMIES_FAILURE, payload: error, }),
  resetDeleteAcademies: () => ({ type: types.RESET_DELETE_ACADEMIES }),

  getAcademyDeleteImpact: (idAcademia, force = false) => ({ type: types.GET_ACADEMY_DELETE_IMPACT_BEGINS, idAcademia, force }),
  successGetAcademyDeleteImpact: (idAcademia, data) => ({ type: types.GET_ACADEMY_DELETE_IMPACT_SUCCESS, idAcademia, payload: data }),
  errorGetAcademyDeleteImpact: (idAcademia, error) => ({ type: types.GET_ACADEMY_DELETE_IMPACT_FAILURE, idAcademia, payload: error }),
}

export default AcademiesReducer;
